
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { FileIcon } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

interface PlotExpenseWithCategory {
  id: string;
  amount: number;
  description: string | null;
  receipt_url: string | null;
  expense_categories: {
    name: string;
  };
}

interface PlotExpenseTableProps {
  expenses: Array<PlotExpenseWithCategory>;
}

export const PlotExpenseTable = ({ expenses }: PlotExpenseTableProps) => {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead className="text-base w-[20%]">Categoría</TableHead>
          <TableHead className="text-base w-[40%]">Descripción</TableHead>
          <TableHead className="text-base w-[20%] text-right">Monto</TableHead>
          <TableHead className="text-base w-[20%] text-center">Comprobante</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {expenses.map((expense) => (
          <TableRow key={expense.id}>
            <TableCell className="text-base">{expense.expense_categories.name}</TableCell>
            <TableCell className="text-base">{expense.description || "-"}</TableCell>
            <TableCell className="text-base text-right">
              ${expense.amount.toLocaleString('es-ES', { maximumFractionDigits: 0 }).replace(/,/g, '.')}
            </TableCell>
            <TableCell className="text-base text-center">
              {expense.receipt_url ? (
                <TooltipProvider>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <a 
                        href={expense.receipt_url} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="inline-flex items-center justify-center w-8 h-8 text-blue-600 hover:text-blue-800"
                      >
                        <FileIcon className="w-5 h-5" />
                      </a>
                    </TooltipTrigger>
                    <TooltipContent>
                      <p>Ver comprobante</p>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              ) : (
                "-"
              )}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
